import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaStar } from "react-icons/fa";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../css/ReviewList.css";

const API_URL = process.env.REACT_APP_APP_URL;
const X_PLATFORM = process.env.REACT_APP_X_PLATFORM;
const API_KEY = process.env.REACT_APP_API_KEY;
const X_API_Version = process.env.REACT_APP_X_API_VERSION;

const ReviewList = ({ roomTypeId }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }
    setLoading(true);
    axios
      .get(`${API_URL}/get/rating/${roomTypeId}`, {
        headers: {
          "Content-Type": "application/json",
          "X-Platform": X_PLATFORM,
          "API-Key": API_KEY,
          Authorization: `Bearer ${token}`,
          "X-API-Version": X_API_Version,
        },
      })
      .then((response) => {
        if (response.data.success) {
          setReviews(response.data.room_type.ratings);
        } else {
          setError("Failed to load reviews.");
        }
      })
      .catch((err) => {
        console.error(err);
        if (err.response && err.response.status === 401) {
          localStorage.removeItem("token");
          navigate("/login");
        } else {
          setError("Failed to load reviews.");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [roomTypeId, navigate]);

  const computeInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(" ");
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }

    return (words[0][0] + words[1][0]).toUpperCase();
  };

  if (loading) {
    return (
      <div className="review-list-loading">
        <p>Loading reviews...</p>
      </div>
    );
  }

  if (error) {
    Swal.fire({
      title: "Error!",
      text: error,
      icon: "error",
      confirmButtonColor: "#d33",
    });
    return (
      <div className="review-list-error">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="review-list">
      {reviews.length === 0 ? (
        <p className="no-reviews">No reviews available.</p>
      ) : (
        reviews.map((review) => (
          <div className="review-item" key={review.id}>
            <div className="profile-icon">
              {computeInitials(review.user.name)}
            </div>
            <div className="review-content">
              <div className="review-header">
                <span className="reviewer-name">{review.user.name}</span>
                <span className="review-date">
                  {moment(review.created_at).format("MMM D, YYYY")}
                </span>
              </div>
              <div className="review-rating">
                {[...Array(5)].map((_, index) => {
                  const starValue = index + 1;
                  return (
                    <FaStar
                      key={index}
                      color={starValue <= review.rating ? "#ffc107" : "#e4e5e9"}
                      size={18}
                    />
                  );
                })}
              </div>
              <p className="review-text">{review.review}</p>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ReviewList;
